import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ServiceProposition } from '../../Constants/Enums/ServiceProposition';

declare var IS_RUNNING_IN_APP_POOL;

export class CompanyServicePropositionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(actorId: number, hierarchyId: string): Promise<Array<ServiceProposition>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/CompanyServiceProposition/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId, hierarchyId: hierarchyId }

    return AjaxWrapper.get<Array<ServiceProposition>, any>(url, data);
  }
}

